<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <li style="font-size: 13px">供应商详情</li>
        <li style="flex: 1; text-align: center; font-weight: 600">
          {{ state.model.name }}
        </li>
        <li>
          <el-button
            type="primary"
            link
            icon="Edit"
            @click="state.showEdit = true"
            v-if="$judge_auth('53')"
          >
            编辑信息
          </el-button>
        </li>
      </ul>
      <el-descriptions
        :column="4"
        border
        style="margin: 10px"
        class="desc-label-nowrap"
        size="large"
      >
        <el-descriptions-item label="状态" label-align="right">
          <div
            style="width: 300px"
            :style="{ color: state.model.status == 1 ? '#1e90ff' : '#f00' }"
          >
            {{ state.model.status == 1 ? "正常" : "停用" }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="名称" label-align="right">
          <div style="width: 300px">
            {{ state.model.name }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="统一社会信用代码" label-align="right">
          <div style="width: 300px">
            {{ state.model.unified_social_credit_identifier }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="业务员" label-align="right">
          <div style="width: 300px; display: flex">
            {{ state.model.belonger_name }}
            <text v-if="state.model.belonger_department_name">
              {{ "/" + state.model.belonger_department_name }}
            </text>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="联系姓名" label-align="right">
          <div style="width: 300px">
            {{ state.model.contact_name }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="职务" label-align="right">
          <div style="width: 300px">
            {{ state.model.contact_job }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="联系方式" label-align="right">
          <div style="width: 300px">
            {{ state.model.contact_name }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="所属地区" label-align="right" :span="3">
          <div style="width: 300px">
            {{
              state.model.province +
              (state.model.city || "") +
              (state.model.district || "")
            }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="详细地址" label-align="right">
          {{ state.model.address }}
        </el-descriptions-item>
      </el-descriptions>
      <ul
        style="
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
        >
          <el-tab-pane label="结算单位" name="jsdw">
            <c_SettleUnit
              :supplier_id="props.data?.id"
              v-if="state.activeName == 'jsdw'"
            ></c_SettleUnit>
          </el-tab-pane>
          <el-tab-pane label="算税单" name="ssd">
            <c_CalcTax
              :supplier_id="props.data?.id"
              v-if="state.activeName == 'ssd'"
            ></c_CalcTax>
          </el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑供应商"
      @close="state.showEdit = false"
    >
      <c_SupplierInfo
        @close="
          state.showEdit = false;
          onLoad();
        "
        :id="props.data?.id"
      ></c_SupplierInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { supplier_detail } from "@/http/supplier";

import c_SettleUnit from "./Detail/SettleUnit/List.vue";
import c_CalcTax from "./Detail/CalcTax/List.vue";
export default {
  components: {
    c_SettleUnit,
    c_CalcTax,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      activeName: "jsdw",
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      supplier_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };
    return { state, props, onLoad };
  },
};
</script>
<style scoped lang="less">
.cus-desc {
  & > div {
    width: 25%;
  }
}
</style>
